import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=60c80b03&scoped=true&"
import script from "./AccountForm.vue?vue&type=script&lang=js&"
export * from "./AccountForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=60c80b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c80b03",
  null
  
)

export default component.exports